export const ENGINE_DEPTH = 9;
export const ENGINE_MOVETIME_FAST_MS = 300; // moves 100-150
export const ENGINE_MOVETIME_SLOW_MS = 400; // moves 1-99
export const MAX_FULL_MOVES = 150; // force draw at or beyond this
export const EARLY_END_IF_SIDE_EMPTY = true; // end round early if a side has only a king

export const SHOP_SLOTS = 5;

export const PIECE_COSTS = { p: 1, n: 3, b: 3, r: 5, q: 9 };

export const FINAL_ROUND_NUMBER = 30;

export const GAME_STATES = {
  SETUP: 'SETUP',
  SEEDING_BLACK: 'SEEDING_BLACK',
  BATTLE_RUNNING: 'BATTLE_RUNNING',
  GAME_OVER: 'GAME_OVER',
  RETURN_TO_SETUP: 'RETURN_TO_SETUP'
};


